<script setup>
import {ref, onUpdated, watch, nextTick} from "vue"
import Header from '@/components/Header/newIndex.vue'
import Menu from '@/components/Menu/newIndex.vue'
import {getRoute} from "@/hooks/getRoute.js"

const {route} = getRoute()
const bread = ref(route.meta.bread)
onUpdated(() => {
  bread.value = route.meta.bread
})

watch(
    () => route.fullPath,
    async () => {
      bread.value = route.meta.bread

      await nextTick()

      const mainBox = document.querySelector('.new_main_box')
      if (mainBox) {
        mainBox.scrollTop = 0
      }
    },
    { immediate: true }
)
</script>

<template>
  <div class="full_v flex_align_t new_box" style="overflow: hidden">
    <div style="height: 100vh;background-color:#F9FAFE;">
      <Menu :bread="bread" />
    </div>
    <div class="new_content_box">
      <Header :bread="bread"/>
      <div class="new_main_box">
        <router-view/>
      </div>
    </div>
  </div>
  <el-backtop :target="'.new_main_box'" :bottom="100">
    <v-btn icon="mdi-arrow-collapse-up" color="#1a1a1a" variant="flat" size="small"></v-btn>
  </el-backtop>
</template>

<style lang="scss" scoped>
/*引入新样式*/
@use "@/assets/css/YTComponents.scss";
.new_box {
  font-family: 'OPPOSans', sans-serif;
  font-weight: 400;
}
</style>
